import PropTypes from 'prop-types';

const Comments = ({ value = 0 }) => (
  <svg
    width='29'
    height='29'
    viewBox='0 0 29 29'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Comment</title>
    <g
      id='Styles-v2'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Comment'>
        <path
          d='M14.5,1 C6.49116667,1 0,6.61231818 0,13.5341364 C0,16.4673182 1.12616667,19.1685455 2.932625,21.0990455 L0,28 L9.138625,25.2263636 C20.61175,28.4148182 29,21.2365 29,13.5341364 C29,6.61231818 22.5088333,1 14.5,1 L14.5,1 Z'
          id='$'
          fill='#F1E1C4'
        />
        <text
          id='@'
          fontFamily='ALSMirta-Regular, ALS Mirta'
          fontSize='14'
          fontWeight='normal'
          fill='#000000'
        >
          <tspan
            x='14'
            y='18'
            textAnchor='middle'
          >
            {value}
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

Comments.propTypes = {
  value: PropTypes.number,
};

export default Comments;
